import { observable, action, computed } from 'mobx';
import { userBehaviorTrackingService} from './services/index'

class UserStore {
    @observable test = '';
    @computed get newTest(){
        return test
      }
    @action testFun(){

    }
    @action doSendGAEvent({eventKey,extraInformation}){
        userBehaviorTrackingService.doSendGAEvent({eventKey,extraInformation})
    }

}
export default UserStore;